export const alertShipmentTypes = {
  FETCH_REQUEST: "ALERT_SHIPMENT_FETCH_REQUEST",
  FETCH_SUCCESS: "ALERT_SHIPMENT_FETCH_SUCCESS",
  UPDATE_FILTERS: "ALERT_SHIPMENT_UPDATE_FILTERS",
  FETCH_FAILURE: "ALERT_FETCH_FAILURE",
  ALERT_COUNT_SUCCESS: "ALERT_ALERT_COUNT_SUCCESS",
  BULK_UPDATE_FILTER_FIELD: "ALERT_BULK_SHIPMENT_UPDATE_FILTER_FIELD",
  BULK_UPDATE_FIELD: "ALERT_BULK_SHIPMENT_UPDATE_FIELD",
  BULK_UPDATE_FILTER_BACK: "ALERT_BULK_SHIPMENT_UPDATE_FILTER_BACK",
  BULK_UPDATE_FILTER: "ALERT_BULK_SHIPMENT_UPDATE_FILTER",
  BULK_UPDATE_FILTER_SUCCESS: "ALERT_BULK_SHIPMENT_UPDATE_FILTER_SUCCESS",
  BULK_UPDATE_FILTER_FAILURE: "ALERT_BULK_SHIPMENT_UPDATE_FILTER_FAILURE",
  BULK_UPDATE_SUBMIT: "ALERT_BULK_SHIPMENT_UPDATE_SUBMIT",
  BULK_UPDATE_RESPONSE: "ALERT_BULK_SHIPMENT_UPDATE_RESPONSE",
  SINGLE_UPDATE_REQUEST: "ALERT_SINGLE_UPDATE_REQUEST",
  SINGLE_UPDATE_SUBMIT: "ALERT_SINGLE_UPDATE_SUBMIT",
  SINGLE_UPDATE_FIELD: "ALERT_SINGLE_UPDATE_FIELD",
  SINGLE_UPDATE_RESPONSE: "ALERT_SINGLE_UPDATE_RESPONSE",
  DOWNLOAD_REQUEST: "ALERT_SHIPMENT_DOWNLOAD_REQUEST",
  DOWNLOAD_SUCCESS: "ALERT_SHIPMENT_DOWNLOAD_SUCCESS",
  DOWNLOAD_FAILURE: "ALERT_SHIPMENT_DOWNLOAD_FAILURE",
  RESET_BULK_UPDATE_FORM: "ALERT_RESET_BULK_SHIPMENT_UPDATE_FORM",
};

export const fetchRequest = (filter) => ({
  type: alertShipmentTypes.FETCH_REQUEST,
  payload: filter,
});

export const fetchSuccess = (resp) => ({
  type: alertShipmentTypes.FETCH_SUCCESS,
  payload: resp,
});

export const updateFilters = (resp) => ({
  type: alertShipmentTypes.UPDATE_FILTERS,
  payload: resp,
});

export const alertAlertCountSuccess = (resp) => ({
  type: alertShipmentTypes.ALERT_COUNT_SUCCESS,
  payload: resp,
});

export const fetchFailure = (resp) => ({
  type: alertShipmentTypes.FETCH_FAILURE,
  payload: resp,
});

export const bulkUpdateFilterField = (field) => ({
  type: alertShipmentTypes.BULK_UPDATE_FILTER_FIELD,
  payload: field,
});

export const bulkUpdateField = (filter) => ({
  type: alertShipmentTypes.BULK_UPDATE_FIELD,
  payload: filter,
});

export const bulkUpdateFilter = (filter) => ({
  type: alertShipmentTypes.BULK_UPDATE_FILTER,
  payload: filter,
});

export const bulkUpdateFilterBack = () => ({
  type: alertShipmentTypes.BULK_UPDATE_FILTER_BACK,
});

export const bulkUpdateFilterSuccess = (count) => ({
  type: alertShipmentTypes.BULK_UPDATE_FILTER_SUCCESS,
  payload: count,
});

export const bulkUpdateFilterFailure = () => ({
  type: alertShipmentTypes.BULK_UPDATE_FILTER_FAILURE,
});

export const bulkUpdateSubmit = (selectedItems) => ({
  type: alertShipmentTypes.BULK_UPDATE_SUBMIT,
  payload:selectedItems
});

export const bulkUpdateResponse = (resp) => ({
  type: alertShipmentTypes.BULK_UPDATE_RESPONSE,
  payload: resp,
});

export const singleUpdateRequest = (filter) => ({
  type: alertShipmentTypes.SINGLE_UPDATE_REQUEST,
  payload: filter,
});

export const singleUpdateField = (filter) => ({
  type:alertShipmentTypes.SINGLE_UPDATE_FIELD,
  payload: filter,
});

export const singleUpdateSubmit = () => ({
  type:alertShipmentTypes.SINGLE_UPDATE_SUBMIT,
});

export const singleUpdateResponse = (resp) => ({
  type: alertShipmentTypes.SINGLE_UPDATE_RESPONSE,
  payload: resp,
});

export const downloadRequest = (total) => ({
  type: alertShipmentTypes.DOWNLOAD_REQUEST,
  payload: total,
});

export const downloadSuccess = (resp) => ({
  type: alertShipmentTypes.DOWNLOAD_SUCCESS,
  payload: resp,
});

export const downloadFailure = (error) => ({
  type:alertShipmentTypes.DOWNLOAD_FAILURE,
  payload: error,
});

export const resetBulkUpdateForm = () => ({
  type: alertShipmentTypes.RESET_BULK_UPDATE_FORM,
});
